// Generated by purs version 0.14.3
"use strict";
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Network_Ethereum_Core_BigNumber = require("../Network.Ethereum.Core.BigNumber/index.js");
var Network_Ethereum_Web3_Solidity_Size = require("../Network.Ethereum.Web3.Solidity.Size/index.js");
var UIntN = function (x) {
    return x;
};
var unUIntN = function (dictKnownSize) {
    return function (v) {
        return v;
    };
};
var uIntNFromBigNumber = function (dictKnownSize) {
    return function (v) {
        return function (a) {
            if (Data_Ord.lessThan(Network_Ethereum_Core_BigNumber.ordBigNumber)(a)(Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber))) {
                return Data_Maybe.Nothing.value;
            };
            if (Data_Boolean.otherwise) {
                var maxVal = Data_Ring.sub(Network_Ethereum_Core_BigNumber.ringBigNumber)(Network_Ethereum_Core_BigNumber.pow(Network_Ethereum_Core_BigNumber.embed(Network_Ethereum_Core_BigNumber["embedInt'"])(2))(Network_Ethereum_Web3_Solidity_Size.sizeVal(dictKnownSize)(Network_Ethereum_Web3_Solidity_Size.DLProxy.value)))(Data_Semiring.one(Network_Ethereum_Core_BigNumber.semiringBigNumber));
                var $7 = Data_Ord.greaterThan(Network_Ethereum_Core_BigNumber.ordBigNumber)(a)(maxVal);
                if ($7) {
                    return Data_Maybe.Nothing.value;
                };
                return Data_Maybe.Just.create(UIntN(a));
            };
            throw new Error("Failed pattern match at Network.Ethereum.Web3.Solidity.UInt (line 32, column 1 - line 32, column 89): " + [ v.constructor.name, a.constructor.name ]);
        };
    };
};
var showUIntN = Network_Ethereum_Core_BigNumber.showBigNumber;
var ordUIntN = Network_Ethereum_Core_BigNumber.ordBigNumber;
var eqUIntN = Network_Ethereum_Core_BigNumber.eqBigNumber;
module.exports = {
    unUIntN: unUIntN,
    uIntNFromBigNumber: uIntNFromBigNumber,
    showUIntN: showUIntN,
    eqUIntN: eqUIntN,
    ordUIntN: ordUIntN
};
